export default __webpack_public_path__ + "static/media/bart_head.46a2bc15.png";